import { createAction, props } from '@ngrx/store';
import { UserAccount } from '../../../management/models';

export const getCurrentClientUserAccounts = createAction(
  '[UserAccounts] Get Current Client User Accounts',
);

export const getCurrentClientUserAccountsSuccess = createAction(
  '[UserAccounts/API] Get Current Client User Accounts Success',
  props<{ data: UserAccount[] }>()
);

export const getCurrentClientUserAccountsFailure = createAction(
  '[UserAccounts/API] Get Current Client User Accounts Failure',
  props<{ error: any }>()
);

export type UserAccountsActionsUnion = ReturnType<
  typeof getCurrentClientUserAccounts |
  typeof getCurrentClientUserAccountsSuccess |
  typeof getCurrentClientUserAccountsFailure
>;
